<template>
  <el-container class="PlanForm">
    <el-main class="p-0">
      <el-form :model="data" :rules="rules" inline ref="form" label-width="85px" class="columns-3">
        <el-form-item label="품목" prop="product_id">
          <AProductSelector
            :value="data.product_name"
            :disabled="!isEditable"
            @select="handleSelectProduct"
          />
        </el-form-item>
        <el-form-item :label="$t('lang.size')" prop="size">
          <el-input v-model="data.size" />
        </el-form-item>
        <el-form-item :label="$t('lang.amount')" prop="plan_amount" class="custom-form-item">
          <el-input-number v-model="data.plan_amount" :min="1" :max="100" controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('lang.production_plan_date')" prop="plan_date" class="small-font">
          <ADatePicker v-model="data.plan_date" />
        </el-form-item>
        <el-form-item label="생산번호" prop="code">
          <el-input v-model="data.code" class="readonly" readonly />
        </el-form-item>
        <div>
          <el-form-item label="거래처" prop="customer_id">
            <ACustomerSelector
              v-model="data.customer_name"
              :disabled="!isEditable"
              @select="handleSelectCustomer"
            />
          </el-form-item>
          <el-form-item
            :label="$t('lang.specification')"
            prop="specification"
            class="custom-form-item width-auto"
          >
            <el-input v-model="data.specification" class="specification" />
          </el-form-item>
        </div>
        <el-form-item :label="$t('lang.delivery_date')" prop="delivery_date">
          <ADatePicker
            v-model="data.delivery_date"
            :disabled="!isEditable"
          />
        </el-form-item>
        <el-form-item label="수주량" prop="contract_amount" class="custom-form-item">
          <el-input-number
            v-model="data.contract_amount"
            :min="0"
            :max="100"
            :disabled="!isEditable"
            controls-position="right"
          ></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('lang.shipping_mode')" prop="location">
          <ADeliveryWaySelector v-model="data.delivery_way_flag" />
        </el-form-item>
      </el-form>
    </el-main>
    <el-footer>
      <el-button
        type="primary"
        v-shortkey="['f4']"
        @shortkey.native="handleClickRegister"
        @click="handleClickRegister"
      >생산 등록(F4)</el-button>
      <el-button type="danger" v-if="!isNew" :disabled="!isDeletable" @click="clickDel">삭제</el-button>
      <el-button class="close-button" @click="closeDialog">{{$t('button.close')}}(Esc)</el-button>
    </el-footer>
  </el-container>
</template>

<script>
// import {mapGetters} from "vuex";
import { form } from "@/common/mixins/form";
import { production_process } from "@/common/mixins/production_process";

export default {
  name: "PlanForm",
  mixins: [form, production_process],
  data() {
    return {
      rules: {
        product_id: [{ required: true, message: "품목을 선택해 주세요." }],
        plan_amount: [{ required: true, message: "생산량을 입력해 주세요." }],
        plan_date: [{ required: true, message: "생산계획일을 선택해 주세요." }],
        process_id: [{ required: true, message: "공정번호를 선택해 주세요." }]
      }
    };
  },
  props: {
    data: {
      type: Object,
      default: function() {
        return {
          id: 0,
          product_id: null,
          product_name: "",
          plan_amount: 1,
          plan_date: null,
          code: null,
          process_id: null,
          delivery_way_flag: null,
          status_flag: null,
          customer_id: null,
          customer_name: "",
          destination: "",
          delivery_date: "",
          contract_amount: 0,
          amount: 0
        };
      }
    }
  },
  computed: {
    // ...mapGetters(["product"]),
    isNew: function() {
      return this.data.id < 1;
    },
    isEditable: function() {
      return !this.data.contract_detail_id;
    },
    isDeletable: function() {
      return this.data.amount === 0;
    }
  },
  methods: {
    handleClickRegister() {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return;
        }
        this.doRegister();
      });
    },
    handleSelectProduct(product) {
      if (typeof product !== "object") {
        return;
      }
      this.data.product_id = product.id;
      this.data.product_name = product.name;
    },
    handleSelectCustomer(customer) {
      if (typeof customer === "string") {
        this.data.customer_id = null;
        this.data.customer_name = customer;
        this.data.location = "";
        this.data.tel = "";
        this.data.addr = "";
      } else {
        this.data.customer_id = customer.id;
        this.data.customer_name = customer.name;
        if (this.data.destination.length < 1) {
          this.data.destination = customer.location;
        }
      }
    },
    doRegister() {
      if (this.data.delivery_date === "") {
        this.data.delivery_date = null;
      }
      if (this.isNew) {
        this.processProduction(
          "생산 등록 중입니다.",
          () => this.api.createProduction(this.data),
          {
            success: () => this.completed("등록되었습니다."),
            error: res => this.notifyError(res.message)
          }
        );
      } else {
        this.processProduction(
          "생산 수정 중입니다.",
          () => this.api.updateProduction(this.data),
          {
            success: () => this.completed("수정되었습니다."),
            error: res => this.notifyError(res.message)
          }
        );
      }
    },
    clickDel() {
      this.util.confirm_delete(
        this,
        this.$t("lang.production") + "[" + this.data.product_name + "]",
        this.doDelete
      );
    },
    doDelete() {
      // const data = this.organizeData();
      let params = [this.data.id];
      this.processProduction(
        "생산 취소 중입니다.",
        () => this.api.deleteProduction(params),
        {
          success: () => this.completed("삭제되었습니다."),
          error: res => this.notifyError(res.message)
        }
      );
    },
    notifyError(message) {
      this.util.notify_error(this, this.$t("lang.production"), message);
    },
    completed(message) {
      const options = this.util.get_notify_options("s", "계약", message);
      this.$emit("completed", options);
    }
  }
};
</script>

<style scoped>
.specification {
  width: 430px;
}
</style>